import { useContext, useState } from "react";

import { Avatar, CircularProgress, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import PhotoCamera from '@mui/icons-material/PhotoCamera';

import styled from "@emotion/styled";
import { AppContext } from "../../scripts/context/App";
import axios from "axios";
import toast from "react-hot-toast";

const Input = styled('input')({
  display: 'none',
});
const Label = styled('label')({
  position: 'absolute',
  right: 0,
  bottom: 0,
  backgroundColor: '#fff',
  borderRadius: '50%',
  "& .MuiIconButton-root": {
    padding: "0",
    width: "30px",
    height: "30px",
    svg: {
      width: "20px",
    }
  }
});

export default function ChangeAvatar() {
  const { user, setState } = useContext(AppContext);
  const [progress, setProgress] = useState(0);

  const updateImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files?.[0].type.includes("image")) return toast.error("Please upload an image");
    const file = event.target.files?.[0] || "";

    const formData = new FormData();
    formData.append("avatar", file);

    const progress = (percentCompleted: any) => {
      setProgress(percentCompleted);
    };

    axios.post("/profile/change-avatar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        progress(percentCompleted);
      },
    }).then(({ data }) => {
      setProgress(0);
      setState({ user: { ...user, avatar: data.avatar } })
    }).catch(err => {
      setProgress(0);
      if (err.response.data.errors) {
        toast.error(err.response.data.errors.avatar[0]);
      } else {
        toast.error(err.response.data.message);
      }
    })
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          sx={{
            width: "70px !important",
            height: "70px !important",
          }} variant="determinate" value={progress}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Avatar
            src={user.avatar}
            alt="avatar"
            sx={{
              width: "60px",
              height: "60px",
            }}
          />
        </Box>
      </Box>

      <Label htmlFor="icon-button-file">
        <Input accept="image/*" id="icon-button-file"
          type="file" onChange={updateImage}
        />
        <IconButton color="primary" aria-label="upload picture" component="span">
          <PhotoCamera />
        </IconButton>
      </Label>
    </Box>
  )
}